import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import IFaq from "../../types/FaqType";
import FaqService from "../../services/FaqService";
import { initialValues } from "./InitialValues";

const CreateFaq = () => {
  const navigate = useNavigate();

  const [card, setCard] = useState<IFaq>(initialValues);
  const [loading, setLoading] = useState<Boolean>(false);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setCard({ ...card, [name]: value });
  };

  const createCard = () => {
    setLoading(true);
    var data = {
      questionRu: card.questionRu,
      questionUzk: card.questionUzk,
      questionUz: card.questionUz,
      answerRu: card.answerRu,
      answerUzk: card.answerUzk,
      answerUz: card.answerUz,
      for: card.for,
    };

    console.log(data);

    FaqService.create(data)
      .then((response: any) => {
        setCard({
          _id: response.data.data.faq._id,
          questionRu: response.data.data.faq.questionRu,
          questionUzk: response.data.data.faq.questionUzk,
          questionUz: response.data.data.faq.questionUz,
          answerRu: response.data.data.faq.answerRu,
          answerUzk: response.data.data.faq.answerUzk,
          answerUz: response.data.data.faq.answerUz,
          for: response.data.data.faq.for,
        });
        if (response.data.status === "success") {
          setLoading(false);
          navigate("/faq");
          toast("Created successfully");
        }
      })
      .catch((e: any) => {
        setLoading(false);
        toast.error(e.message, {
          position: "top-right",
          autoClose: 5000,
        });
      });
  };

  useEffect(() => {}, [navigate]);

  return (
    <div>
      <h1 className="d-flex align-items-center text-dark fw-bolder my-1 fs-3">
        Create faq
      </h1>
      <div className="modal-body py-10 px-lg-17">
        <div className="scroll-y me-n7 pe-7">
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fs-6 fw-bold mb-2">Question Ru</label>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder=""
              name="questionRu"
              value={card.questionRu}
              onChange={handleInputChange}
            />
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fs-6 fw-bold mb-2">Question Uzk</label>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder=""
              name="questionUzk"
              value={card.questionUzk}
              onChange={handleInputChange}
            />
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Question Uz</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="questionUz"
                onChange={handleInputChange}
                value={card.questionUz}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Answer Ru</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="answerRu"
                onChange={handleInputChange}
                value={card.answerRu}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Answer Uzk</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="answerUzk"
                onChange={handleInputChange}
                value={card.answerUzk}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Answer Uz</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="answerUz"
                onChange={handleInputChange}
                value={card.answerUz}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">For</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="for"
                onChange={handleInputChange}
                value={card.for}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row justify-content-end">
            <button
              className="btn btn-primary d-flex ml-auto"
              style={{
                width: "fit-content",
              }}
              onClick={createCard}
            >
              Submit
              <span className={`indicator-${loading ? "label" : "progress"}`}>
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateFaq;
